import { FunctionComponent } from 'react';
import Form, { FormProps } from 'antd/lib/form';
import styled from 'styled-components';

export const ContractLoading = styled.section`
  display: flex;
  justify-content: center;
  padding-top: 10rem;
  min-height: 30rem;
`;

export const ContractFormStyled: FunctionComponent<FormProps> = styled(Form)`
  padding-top: 1.5rem;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const ContractFormTitle = styled.h2`
  font-weight: 600;
  font-size: 1.625rem;
`;
